import network from "./AdminNetwork";
import { publicEnv } from "./runtimeEnv";

const EnvName = publicEnv("REACT_APP_ENVIRONMENT", process.env.REACT_APP_ENVIRONMENT, "local");
const IPFS_IMG = publicEnv("REACT_APP_IPFS_GATEWAY", process.env.REACT_APP_IPFS_GATEWAY, "https://ipfs.io/ipfs");
const Back_Url = publicEnv("REACT_APP_BACKEND_URL", process.env.REACT_APP_BACKEND_URL, "http://localhost:2001").replace(/\/$/, "");
const Front_URL = publicEnv("REACT_APP_ADMIN_URL", process.env.REACT_APP_ADMIN_URL, "http://localhost:3001");
const defaultNetworkName = publicEnv(
  "REACT_APP_ADMIN_DEFAULT_NETWORK",
  process.env.REACT_APP_ADMIN_DEFAULT_NETWORK,
  "ETH",
).toUpperCase();
const defaultnet = network[defaultNetworkName] || network.ETH;

const key = {
  secretOrKey: "",
  Recaptchakey: publicEnv("REACT_APP_RECAPTCHA_SITE_KEY", process.env.REACT_APP_RECAPTCHA_SITE_KEY),
  API: `${Back_Url}/v1`,
  IMAGE_URL: `${Back_Url}/images/user`,
  exchangeAddress: defaultnet.exchangeAddress,
  toasterOption: {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  },
  IPFS_IMG,
  networkVersion: defaultnet.networkVersion,
  adminaddress: defaultnet.adminAddress,
  decimalValues: 1000000000000000000,
  Back_Url,
  singleContract: defaultnet.singleContract,
  multipleContract: defaultnet.multipleContract,
  BNBProvider: defaultnet.BNBPROVIDER,
  TradeContract: defaultnet.TradeContract,
  Front_URL,
  trade: defaultnet.trade,
  v1Url: `${Back_Url}/v1`,
  KEY: publicEnv("REACT_APP_CLIENT_ENCRYPTION_KEY", process.env.REACT_APP_CLIENT_ENCRYPTION_KEY),
  walletConnectProjectId: publicEnv(
    "REACT_APP_WALLETCONNECT_PROJECT_ID",
    process.env.REACT_APP_WALLETCONNECT_PROJECT_ID,
  ),
  marketplaceUrl: publicEnv(
    "REACT_APP_MARKETPLACE_URL",
    process.env.REACT_APP_MARKETPLACE_URL,
  ),
  marketplaceIconUrl: publicEnv(
    "REACT_APP_MARKETPLACE_ICON_URL",
    process.env.REACT_APP_MARKETPLACE_ICON_URL,
  ),
  adminCookieName: "adminToken",
  EnvName,
  EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/,
  adminWalletAddressKey: "adminaddress",
};

export default key;
